import React, { useState } from "react";
import {
  Button,
} from "reactstrap";

export default function CommandButtons({
  getAllRegistersByEventId,
  groups,
  modalStandReportControl,
  setModalStandReportControl
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        marginBottom: 10,
      }}
    >
      <div className="header-btns-container">
        <Button
          color="primary"
          className="btn-rounded waves-effect waves-light events-button-add-lg"
          onClick={() => getAllRegistersByEventId()}
        >
          Exportar Relatório
        </Button>
        {groups && groups.length > 0 && (
          <Button
            color="secondary"
            className="btn-rounded waves-effect waves-light events-button-add-lg"
            onClick={() => setModalStandReportControl({
              ...modalStandReportControl,
              open: true,
              group: '',
            })}
          >
            Exportar Relatório por Stand
          </Button>
        )}
      </div>
    </div>
  )
}
